import { render } from "./WalletButton.vue?vue&type=template&id=4dafe01e&ts=true"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=4dafe01e&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__